export default __webpack_public_path__ + "static/media/flag-northen-cyprus.2d480eca.svg";